import { jsonldArticleType } from './JsonldStore';

export const updateJsonldArticleType = (value) => jsonldArticleType.update((oldValue) => value);
